function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12 20.512c-.365 0-1.044 0-4.794-3.547-1.776-1.68-3.416-3.382-3.433-3.4-1.05-1.05-1.633-2.456-1.633-3.953 0-1.496.583-2.903 1.64-3.96C4.84 4.593 6.248 4.01 7.744 4.01c1.497 0 2.904.583 3.962 1.64l.295.295.295-.295c1.057-1.057 2.464-1.64 3.96-1.64 1.498 0 2.905.583 3.964 1.642 1.058 1.057 1.64 2.464 1.64 3.96 0 1.497-.583 2.904-1.64 3.962-.009.009-1.65 1.71-3.426 3.39-3.75 3.548-4.429 3.548-4.793 3.548zM7.743 5.242c-1.167 0-2.265.456-3.09 1.281-.826.825-1.28 1.922-1.28 3.09 0 1.167.455 2.264 1.28 3.09 2.915 3.027 6.52 6.368 7.347 6.572.826-.205 4.432-3.545 7.34-6.564.832-.834 1.287-1.931 1.287-3.099 0-1.167-.454-2.264-1.28-3.089-.826-.826-1.924-1.28-3.091-1.28-1.168 0-2.265.454-3.09 1.28L12 7.687l-1.167-1.166c-.825-.825-1.922-1.28-3.09-1.28z",
  transform: "translate(-120 -395) translate(120 395)"
}))));

var SvgIconFavorilerim = function SvgIconFavorilerim(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFavorilerim, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-favorilerim.eadbd4db.svg";
export { ForwardRef as ReactComponent };